export default "__VITE_ASSET__eREVqc14__"